// Bong monogram (formerly Wu-Pong) — a chunky purple "B" enclosed in
// a stepped frame, with a deeper-violet drop-shadow plate.  Comic-Sans
// glyph to match the rebranded Bong title.
export const WuPongLogo = ({ size = 96 }) => (
  <div
    style={{
      width: size,
      height: size,
      position: "relative",
      display: "inline-block",
    }}
  >
    {/* Deep violet shadow plate */}
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: "#6D28D9",
        transform: "translate(4px, 4px)",
        clipPath:
          "polygon(8% 0%, 92% 0%, 100% 8%, 100% 92%, 92% 100%, 8% 100%, 0% 92%, 0% 8%)",
      }}
    />
    {/* Lavender plate */}
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: "#C084FC",
        clipPath:
          "polygon(8% 0%, 92% 0%, 100% 8%, 100% 92%, 92% 100%, 8% 100%, 0% 92%, 0% 8%)",
      }}
    />
    {/* B letter */}
    <div
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Comic Sans MS','Comic Sans','Chalkboard SE',cursive",
        fontSize: size * 0.55,
        fontWeight: 700,
        color: "#0E0820",
        letterSpacing: "-0.05em",
        lineHeight: 1,
      }}
    >
      B
    </div>
  </div>
);

export default WuPongLogo;
